import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Button } from '../components/ui/Button';
import { Upload, MapPin, Plus, X, Save, ExternalLink, Leaf, Eye, ChevronDown, ChevronUp, Search, Edit2, Check } from 'lucide-react';
const Profile = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showAddLocationModal, setShowAddLocationModal] = useState(false);
  const [showAddCertificationModal, setShowAddCertificationModal] = useState(false);
  const [showAddSustainabilityModal, setShowAddSustainabilityModal] = useState(false);
  const [isLocationsExpanded, setIsLocationsExpanded] = useState(false);
  const [locationSearchTerm, setLocationSearchTerm] = useState('');
  const [newCertification, setNewCertification] = useState('');
  const [newSustainabilityItem, setNewSustainabilityItem] = useState('');
  const [editingCertIndex, setEditingCertIndex] = useState<number | null>(null);
  const [editingCertValue, setEditingCertValue] = useState('');
  const [editingSustainIndex, setEditingSustainIndex] = useState<number | null>(null);
  const [editingSustainValue, setEditingSustainValue] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [toast, setToast] = useState<{
    message: string;
    type: 'success' | 'error';
    show: boolean;
  }>({
    message: '',
    type: 'success',
    show: false
  });
  const [formData, setFormData] = useState({
    logo: 'https://blog.lasaponaria.it/hubfs/LaSaponaria-5.jpg',
    name: 'La Saponaria',
    website: 'https://www.lasaponaria.it/',
    description: 'Marchio italiano di cosmetici naturali, biologici e consapevoli. Società Benefit dal 2023, produciamo cosmetici artigianali con ingredienti biologici certificati, packaging ecologico e produzione 100% italiana con energia rinnovabile.',
    sector: 'Cosmetici Naturali e Biologici',
    founded: '2009',
    headquarters: 'Pesaro, Italia'
  });
  const [certifications, setCertifications] = useState(['Biologico Certificato', 'Società Benefit', 'Cruelty Free', 'Vegan OK']);
  const [sustainabilityItems, setSustainabilityItems] = useState(['Produzione 100% artigianale e italiana con energia rinnovabile', 'Ingredienti biologici certificati e filiere etiche fair trade', 'Packaging plastic-free e opzioni zero-waste (cosmetici solidi, ricariche)', 'Prodotti biodegradabili che non inquinano fiumi, mari e laghi']);
  const [locations, setLocations] = useState([{
    id: 1,
    name: 'Ancona',
    address: 'Corso Mazzini 67'
  }, {
    id: 2,
    name: 'Bastia Umbra',
    address: 'Via Roma 15'
  }, {
    id: 3,
    name: 'Battipaglia',
    address: 'Via Mazzini 91'
  }, {
    id: 4,
    name: 'Bologna',
    address: 'Strada Maggiore 35/C'
  }, {
    id: 5,
    name: 'Civitanova',
    address: 'Corso Umberto I, 79'
  }, {
    id: 6,
    name: 'Fano',
    address: 'Corso Matteotti 124'
  }, {
    id: 7,
    name: 'Milano Centro',
    address: 'Corso Garibaldi 64'
  }, {
    id: 8,
    name: 'Milano Solari',
    address: 'Via Solari 15'
  }, {
    id: 9,
    name: 'Modena',
    address: 'Via Emilia Centro 168'
  }, {
    id: 10,
    name: 'Montebelluna',
    address: 'Piazza Oberkochen 30'
  }, {
    id: 11,
    name: 'Parma',
    address: 'Str. Giuseppe Garibaldi, 1c'
  }, {
    id: 12,
    name: 'Pescara',
    address: 'Via Firenze, 112'
  }, {
    id: 13,
    name: 'Ravenna',
    address: 'Via Cavour 58'
  }, {
    id: 14,
    name: 'Rimini',
    address: 'Via Garibaldi 27'
  }, {
    id: 15,
    name: 'Roma Cola di Rienzo',
    address: 'Via Cola di Rienzo 265/A'
  }, {
    id: 16,
    name: 'Roma Bergamo',
    address: 'Via Bergamo, 4'
  }, {
    id: 17,
    name: 'Sassari',
    address: 'Via Brigata Sassari 46'
  }, {
    id: 18,
    name: 'Senigallia',
    address: 'Via Marchetti 88'
  }, {
    id: 19,
    name: 'Viareggio',
    address: 'Via Battisti 127'
  }, {
    id: 20,
    name: 'Pesaro (Sede e Spaccio)',
    address: 'Via dei Trasporti 3-5'
  }]);
  const handlePreview = () => {
    navigate('/profile/preview', {
      state: {
        profileData: {
          logo: formData.logo,
          name: formData.name,
          website: formData.website,
          description: formData.description,
          sector: formData.sector,
          founded: formData.founded,
          headquarters: formData.headquarters,
          certifications: certifications,
          sustainabilityItems: sustainabilityItems,
          locations: locations
        }
      }
    });
  };
  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      showToast('Profilo aggiornato', 'success');
    }, 1000);
  };
  const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          logo: reader.result as string
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const handleRemoveLocation = (id: number) => {
    setLocations(prev => prev.filter(loc => loc.id !== id));
  };
  // Certification handlers
  const handleAddCertification = () => {
    if (newCertification.trim()) {
      setCertifications([...certifications, newCertification.trim()]);
      setNewCertification('');
      setShowAddCertificationModal(false);
      showToast('Certificazione aggiunta', 'success');
    }
  };
  const handleRemoveCertification = (index: number) => {
    setCertifications(certifications.filter((_, i) => i !== index));
    showToast('Certificazione rimossa', 'success');
  };
  const handleStartEditCertification = (index: number) => {
    setEditingCertIndex(index);
    setEditingCertValue(certifications[index]);
  };
  const handleSaveCertification = (index: number) => {
    if (editingCertValue.trim()) {
      const updated = [...certifications];
      updated[index] = editingCertValue.trim();
      setCertifications(updated);
      setEditingCertIndex(null);
      setEditingCertValue('');
      showToast('Certificazione aggiornata', 'success');
    }
  };
  const handleCancelEditCertification = () => {
    setEditingCertIndex(null);
    setEditingCertValue('');
  };
  // Sustainability handlers
  const handleAddSustainabilityItem = () => {
    if (newSustainabilityItem.trim()) {
      setSustainabilityItems([...sustainabilityItems, newSustainabilityItem.trim()]);
      setNewSustainabilityItem('');
      setShowAddSustainabilityModal(false);
      showToast('Impegno aggiunto', 'success');
    }
  };
  const handleRemoveSustainabilityItem = (index: number) => {
    setSustainabilityItems(sustainabilityItems.filter((_, i) => i !== index));
    showToast('Impegno rimosso', 'success');
  };
  const handleStartEditSustainability = (index: number) => {
    setEditingSustainIndex(index);
    setEditingSustainValue(sustainabilityItems[index]);
  };
  const handleSaveSustainability = (index: number) => {
    if (editingSustainValue.trim()) {
      const updated = [...sustainabilityItems];
      updated[index] = editingSustainValue.trim();
      setSustainabilityItems(updated);
      setEditingSustainIndex(null);
      setEditingSustainValue('');
      showToast('Impegno aggiornato', 'success');
    }
  };
  const handleCancelEditSustainability = () => {
    setEditingSustainIndex(null);
    setEditingSustainValue('');
  };
  const showToast = (message: string, type: 'success' | 'error') => {
    setToast({
      message,
      type,
      show: true
    });
    setTimeout(() => {
      setToast({
        message: '',
        type: 'success',
        show: false
      });
    }, 3000);
  };
  const filteredLocations = locations.filter(location => location.name.toLowerCase().includes(locationSearchTerm.toLowerCase()) || location.address.toLowerCase().includes(locationSearchTerm.toLowerCase()));
  const displayedLocations = isLocationsExpanded ? filteredLocations : filteredLocations.slice(0, 6);
  return <div className="flex h-screen bg-gray-50" data-id="element-1272">
      {/* Desktop Sidebar Wrapper - Hidden on Mobile */}
      <div className="hidden lg:block w-20 flex-shrink-0" data-id="element-1273">
        <Sidebar data-id="element-1274" />
      </div>

      {/* Mobile Sidebar - Overlay */}
      <div className="lg:hidden" data-id="element-1275">
        <Sidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} data-id="element-1276" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1277">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1278" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1279">
          <PageHeader title="Profilo Partner" subtitle="Gestisci le informazioni visibili e operative del tuo account." primaryAction={{
          label: 'Salva Modifiche',
          onClick: handleSave,
          icon: <Save className="h-4 w-4 mr-2" data-id="element-1281" />
        }} secondaryAction={{
          label: 'Anteprima Profilo',
          onClick: handlePreview,
          icon: <Eye className="h-4 w-4 mr-2" data-id="element-1282" />
        }} data-id="element-1280" />

          <div className="space-y-6" data-id="element-1283">
            {/* Identity Section */}
            <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1284">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1285">
                Identità
              </h3>

              {/* Logo Upload */}
              <div className="mb-6" data-id="element-1286">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-1287">
                  Logo
                </label>
                <div className="flex items-center space-x-6" data-id="element-1288">
                  <div className="flex-shrink-0" data-id="element-1289">
                    <div className="h-24 w-24 rounded-lg border-2 border-gray-200 overflow-hidden bg-white flex items-center justify-center p-2" data-id="element-1290">
                      {formData.logo ? <img src={formData.logo} alt="Logo La Saponaria" className="h-full w-full object-contain" data-id="element-1291" /> : <Upload className="h-8 w-8 text-gray-400" data-id="element-1292" />}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-1293">
                    <input type="file" id="logo-upload" accept="image/*" onChange={handleLogoUpload} className="hidden" data-id="element-1294" />
                    <label htmlFor="logo-upload" className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-1295">
                      <Upload className="h-4 w-4 mr-2" data-id="element-1296" />
                      Carica Logo
                    </label>
                    <p className="mt-2 text-xs text-gray-500" data-id="element-1297">
                      PNG, JPG o SVG. Dimensione consigliata: 400x400px
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1298">
                <Input label="Nome Partner" value={formData.name} onChange={e => handleInputChange('name', e.target.value)} required data-id="element-1299" />
                <Input label="Settore" value={formData.sector} onChange={e => handleInputChange('sector', e.target.value)} required data-id="element-1300" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1301">
                <Input label="Anno di Fondazione" value={formData.founded} onChange={e => handleInputChange('founded', e.target.value)} data-id="element-1302" />
                <Input label="Sede Principale" value={formData.headquarters} onChange={e => handleInputChange('headquarters', e.target.value)} data-id="element-1303" />
              </div>

              <div className="mb-6" data-id="element-1304">
                <div className="flex items-center justify-between mb-2" data-id="element-1305">
                  <label className="block text-sm font-medium text-gray-700" data-id="element-1306">
                    Sito Web
                  </label>
                  <a href={formData.website} target="_blank" rel="noopener noreferrer" className="text-sm text-greenback hover:text-greenback/80 flex items-center gap-1" data-id="element-1307">
                    Visita <ExternalLink className="h-3 w-3" data-id="element-1308" />
                  </a>
                </div>
                <Input type="url" value={formData.website} onChange={e => handleInputChange('website', e.target.value)} placeholder="https://example.com" data-id="element-1309" />
              </div>

              <div className="mb-6" data-id="element-1310">
                <Textarea label="Descrizione" value={formData.description} onChange={e => handleInputChange('description', e.target.value)} placeholder="Descrivi brevemente la tua attività e i tuoi valori..." rows={4} helperText={`${formData.description.length}/500 caratteri`} data-id="element-1311" />
              </div>

              {/* Certifications - EDITABLE */}
              <div data-id="element-1312">
                <div className="flex items-center justify-between mb-3" data-id="element-1313">
                  <label className="block text-sm font-medium text-gray-700" data-id="element-1314">
                    Certificazioni e Riconoscimenti
                  </label>
                  <Button variant="ghost" size="sm" onClick={() => setShowAddCertificationModal(true)} leftIcon={<Plus className="h-4 w-4" data-id="element-1316" />} data-id="element-1315">
                    Aggiungi
                  </Button>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-1317">
                  {certifications.map((cert, index) => <div key={index} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 rounded-full text-sm font-medium border border-green-200 group" data-id="element-1318">
                      <Leaf className="h-3.5 w-3.5 flex-shrink-0" data-id="element-1319" />
                      {editingCertIndex === index ? <div className="flex items-center gap-1" data-id="element-1320">
                          <input type="text" value={editingCertValue} onChange={e => setEditingCertValue(e.target.value)} className="bg-white border border-green-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-green-500" autoFocus onKeyDown={e => {
                      if (e.key === 'Enter') handleSaveCertification(index);
                      if (e.key === 'Escape') handleCancelEditCertification();
                    }} data-id="element-1321" />
                          <button onClick={() => handleSaveCertification(index)} className="p-0.5 hover:bg-green-100 rounded transition-colors" title="Salva" data-id="element-1322">
                            <Check className="h-3.5 w-3.5 text-green-600" data-id="element-1323" />
                          </button>
                          <button onClick={handleCancelEditCertification} className="p-0.5 hover:bg-red-100 rounded transition-colors" title="Annulla" data-id="element-1324">
                            <X className="h-3.5 w-3.5 text-red-600" data-id="element-1325" />
                          </button>
                        </div> : <>
                          <span data-id="element-1326">{cert}</span>
                          <button onClick={() => handleStartEditCertification(index)} className="opacity-0 group-hover:opacity-100 p-0.5 hover:bg-green-100 rounded transition-all" title="Modifica" data-id="element-1327">
                            <Edit2 className="h-3 w-3" data-id="element-1328" />
                          </button>
                          <button onClick={() => handleRemoveCertification(index)} className="opacity-0 group-hover:opacity-100 p-0.5 hover:bg-red-100 rounded transition-all" title="Rimuovi" data-id="element-1329">
                            <X className="h-3 w-3 text-red-600" data-id="element-1330" />
                          </button>
                        </>}
                    </div>)}
                  {certifications.length === 0 && <p className="text-sm text-gray-500 italic" data-id="element-1331">
                      Nessuna certificazione aggiunta. Clicca "Aggiungi" per
                      iniziare.
                    </p>}
                </div>
              </div>
            </div>

            {/* Locations Section */}
            <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1332">
              <div className="flex items-center justify-between mb-6" data-id="element-1333">
                <div data-id="element-1334">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-1335">Sedi</h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1336">
                    {locations.length} negozi in tutta Italia
                  </p>
                </div>
                <Button variant="outline" size="sm" onClick={() => setShowAddLocationModal(true)} leftIcon={<Plus className="h-4 w-4" data-id="element-1338" />} data-id="element-1337">
                  Aggiungi Sede
                </Button>
              </div>

              <div className="mb-4" data-id="element-1339">
                <div className="relative" data-id="element-1340">
                  <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-1341" />
                  <input type="text" placeholder="Cerca sede per nome o indirizzo..." className="w-full rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={locationSearchTerm} onChange={e => setLocationSearchTerm(e.target.value)} data-id="element-1342" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1343">
                {displayedLocations.map(location => <div key={location.id} className="flex items-start justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1344">
                    <div className="flex items-start flex-1" data-id="element-1345">
                      <MapPin className="h-5 w-5 text-greenback mt-0.5 mr-3 flex-shrink-0" data-id="element-1346" />
                      <div data-id="element-1347">
                        <p className="font-medium text-gray-900" data-id="element-1348">
                          {location.name}
                        </p>
                        <p className="text-sm text-gray-500 mt-1" data-id="element-1349">
                          {location.address}
                        </p>
                      </div>
                    </div>
                    <button onClick={() => handleRemoveLocation(location.id)} className="ml-4 p-1 text-gray-400 hover:text-red-600 transition-colors" title="Rimuovi sede" data-id="element-1350">
                      <X className="h-5 w-5" data-id="element-1351" />
                    </button>
                  </div>)}
              </div>

              {filteredLocations.length > 6 && <div className="mt-4 text-center" data-id="element-1352">
                  <button onClick={() => setIsLocationsExpanded(!isLocationsExpanded)} className="inline-flex items-center gap-2 px-4 py-2 text-sm text-greenback hover:text-greenback/80 font-medium transition-colors" data-id="element-1353">
                    {isLocationsExpanded ? <>
                        Mostra meno
                        <ChevronUp className="h-4 w-4" data-id="element-1354" />
                      </> : <>
                        Mostra tutte ({filteredLocations.length - 6} in più)
                        <ChevronDown className="h-4 w-4" data-id="element-1355" />
                      </>}
                  </button>
                </div>}

              {filteredLocations.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-1356">
                  <p data-id="element-1357">
                    Nessuna sede trovata con &quot;{locationSearchTerm}&quot;
                  </p>
                </div>}
            </div>

            {/* Sustainability Section - EDITABLE */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-lg border border-green-200 p-6" data-id="element-1358">
              <div className="flex items-start gap-3" data-id="element-1359">
                <Leaf className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-1360" />
                <div className="flex-1" data-id="element-1361">
                  <div className="flex items-center justify-between mb-3" data-id="element-1362">
                    <h3 className="text-lg font-semibold text-gray-900" data-id="element-1363">
                      Impegno per la Sostenibilità
                    </h3>
                    <Button variant="ghost" size="sm" onClick={() => setShowAddSustainabilityModal(true)} leftIcon={<Plus className="h-4 w-4" data-id="element-1365" />} data-id="element-1364">
                      Aggiungi
                    </Button>
                  </div>
                  <ul className="space-y-2 text-sm text-gray-700" data-id="element-1366">
                    {sustainabilityItems.map((item, index) => <li key={index} className="flex items-start gap-2 group" data-id="element-1367">
                        <span className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1368">
                          ✓
                        </span>
                        {editingSustainIndex === index ? <div className="flex-1 flex items-start gap-2" data-id="element-1369">
                            <textarea value={editingSustainValue} onChange={e => setEditingSustainValue(e.target.value)} className="flex-1 bg-white border border-green-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 resize-none" rows={2} autoFocus onKeyDown={e => {
                        if (e.key === 'Enter' && e.ctrlKey) handleSaveSustainability(index);
                        if (e.key === 'Escape') handleCancelEditSustainability();
                      }} data-id="element-1370" />
                            <div className="flex flex-col gap-1" data-id="element-1371">
                              <button onClick={() => handleSaveSustainability(index)} className="p-1 hover:bg-green-100 rounded transition-colors" title="Salva (Ctrl+Enter)" data-id="element-1372">
                                <Check className="h-4 w-4 text-green-600" data-id="element-1373" />
                              </button>
                              <button onClick={handleCancelEditSustainability} className="p-1 hover:bg-red-100 rounded transition-colors" title="Annulla (Esc)" data-id="element-1374">
                                <X className="h-4 w-4 text-red-600" data-id="element-1375" />
                              </button>
                            </div>
                          </div> : <>
                            <span className="flex-1" data-id="element-1376">{item}</span>
                            <div className="opacity-0 group-hover:opacity-100 flex gap-1 transition-opacity" data-id="element-1377">
                              <button onClick={() => handleStartEditSustainability(index)} className="p-1 hover:bg-green-100 rounded transition-colors" title="Modifica" data-id="element-1378">
                                <Edit2 className="h-3.5 w-3.5 text-green-700" data-id="element-1379" />
                              </button>
                              <button onClick={() => handleRemoveSustainabilityItem(index)} className="p-1 hover:bg-red-100 rounded transition-colors" title="Rimuovi" data-id="element-1380">
                                <X className="h-3.5 w-3.5 text-red-600" data-id="element-1381" />
                              </button>
                            </div>
                          </>}
                      </li>)}
                    {sustainabilityItems.length === 0 && <li className="text-gray-500 italic" data-id="element-1382">
                        Nessun impegno aggiunto. Clicca "Aggiungi" per iniziare.
                      </li>}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Add Location Modal */}
      {showAddLocationModal && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setShowAddLocationModal(false)} data-id="element-1383"></div>

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1384">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1385">
              <div className="flex items-center justify-between mb-4" data-id="element-1386">
                <h3 className="text-lg font-semibold" data-id="element-1387">Aggiungi Sede</h3>
                <button onClick={() => setShowAddLocationModal(false)} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-1388">
                  <X className="h-5 w-5 text-gray-500" data-id="element-1389" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-1390">
                <Input label="Nome Sede" placeholder="Es. Milano Centro" data-id="element-1391" />
                <Input label="Indirizzo" placeholder="Via Roma 1, 20121 Milano" data-id="element-1392" />
              </div>

              <div className="flex justify-end gap-3 mt-6" data-id="element-1393">
                <Button variant="outline" onClick={() => setShowAddLocationModal(false)} data-id="element-1394">
                  Annulla
                </Button>
                <Button variant="primary" onClick={() => {
              const newLocation = {
                id: locations.length + 1,
                name: 'Nuova Sede',
                address: 'Indirizzo da configurare'
              };
              setLocations([...locations, newLocation]);
              setShowAddLocationModal(false);
              showToast('Sede aggiunta', 'success');
            }} data-id="element-1395">
                  Aggiungi
                </Button>
              </div>
            </div>
          </div>
        </>}

      {/* Add Certification Modal */}
      {showAddCertificationModal && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setShowAddCertificationModal(false)} data-id="element-1396"></div>

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1397">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1398">
              <div className="flex items-center justify-between mb-4" data-id="element-1399">
                <h3 className="text-lg font-semibold" data-id="element-1400">
                  Aggiungi Certificazione
                </h3>
                <button onClick={() => setShowAddCertificationModal(false)} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-1401">
                  <X className="h-5 w-5 text-gray-500" data-id="element-1402" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-1403">
                <Input label="Nome Certificazione" placeholder="Es. ISO 9001, B Corp, etc." value={newCertification} onChange={e => setNewCertification(e.target.value)} onKeyDown={e => {
              if (e.key === 'Enter') handleAddCertification();
            }} data-id="element-1404" />
              </div>

              <div className="flex justify-end gap-3 mt-6" data-id="element-1405">
                <Button variant="outline" onClick={() => {
              setShowAddCertificationModal(false);
              setNewCertification('');
            }} data-id="element-1406">
                  Annulla
                </Button>
                <Button variant="primary" onClick={handleAddCertification} data-id="element-1407">
                  Aggiungi
                </Button>
              </div>
            </div>
          </div>
        </>}

      {/* Add Sustainability Item Modal */}
      {showAddSustainabilityModal && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setShowAddSustainabilityModal(false)} data-id="element-1408"></div>

          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1409">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1410">
              <div className="flex items-center justify-between mb-4" data-id="element-1411">
                <h3 className="text-lg font-semibold" data-id="element-1412">
                  Aggiungi Impegno Sostenibilità
                </h3>
                <button onClick={() => setShowAddSustainabilityModal(false)} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-1413">
                  <X className="h-5 w-5 text-gray-500" data-id="element-1414" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-1415">
                <Textarea label="Descrizione Impegno" placeholder="Es. Utilizzo di energia 100% rinnovabile..." value={newSustainabilityItem} onChange={e => setNewSustainabilityItem(e.target.value)} rows={3} data-id="element-1416" />
              </div>

              <div className="flex justify-end gap-3 mt-6" data-id="element-1417">
                <Button variant="outline" onClick={() => {
              setShowAddSustainabilityModal(false);
              setNewSustainabilityItem('');
            }} data-id="element-1418">
                  Annulla
                </Button>
                <Button variant="primary" onClick={handleAddSustainabilityItem} data-id="element-1419">
                  Aggiungi
                </Button>
              </div>
            </div>
          </div>
        </>}

      {/* Toast Notification */}
      {toast.show && <div className={`fixed bottom-6 right-6 px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in ${toast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`} data-id="element-1420">
          {toast.message}
        </div>}
    </div>;
};
export default Profile;